import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Section from '../../Utilitis/Section';
import OurPricing from './Home_Component/OurPricing';
import OurTeachers from './Home_Component/OurTeachers';
import PopularCourses from './Home_Component/PopularCourses';
import TestiMonials from './Home_Component/TestiMonials';
import UpcomingEvent from './Home_Component/UpcomingEvent';
import "animate.css/animate.min.css";
import Statistiques from './Home_Component/Statistiques';
import Contact from '../../Utilitis/Contact/Contact';
import Header from '../../Header/Header';
import { motion } from 'framer-motion';
import OurBlogs from './Home_Component/OurBlogs';
import Carousel from 'react-bootstrap/Carousel'
import AboutSection from '../../Utilitis/AboutSection/AboutSection';
import CouresesCategorie from './Home_Component/CouresesCategorie';
import Loader from '../../Utilitis/Loader/Loader';

export default function Home() {

    const options_OwlCarousel = {
        margin: 30,
        responsiveClass: true,
        nav: false,
        autoplay: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            600: {
                items: 1,
            },
            760: {
                items: 2,
            },
            1000: {
                items: 3,
            }
        },
    };

    return (
        <>
        <Loader />
            {/* <motion.div
                initial={{ y: "-100%" }}
                animate={{ y: 0 }}
                exit={{ y: "100%" }}
                transition={{ duration: 0.3 }}
            > */}
                {/****  start Header Section  ****/}

                <Carousel>
                    <Carousel.Item> <Header bg="../images/bg_1.jpg" /> </Carousel.Item>
                    <Carousel.Item> <Header bg="../images/slide-2.jpg" /> </Carousel.Item>
                </Carousel>

                {/****  end Header Section  ****/}

                {/****   Why Choose EDUCATE Section  ****/}

                <Section bg="white">
                    <Container >
                        <Row>
                            <AboutSection />
                        </Row>
                    </Container>
                </Section>

                {/****   Why Choose EDUCATE Section  ****/}

                {/* Start Coureses Categorie Section */}

                <CouresesCategorie />

                {/* end Coureses Categorie Section */}

                {/* Start PopularCourses Section */}

                <PopularCourses option={options_OwlCarousel} />

                {/* End PopularCourses Section */}

                {/* Start Upcoming Event Section */}

                <UpcomingEvent option={options_OwlCarousel} />

                {/* End Upcoming Event Section */}

                {/* Start Statistiques Section */}

                <Statistiques />

                {/* End Statistiques Section */}

                <OurBlogs option={options_OwlCarousel} />
                {/* Start Our Pricing Section */}

                <OurPricing />

                {/* End Our Pricing Section */}

                {/* Strat Our Teachers Section */}

                <OurTeachers />

                {/* Strat Our Teachers Section */}

                {/* Start TestiMonial Section */}

                <TestiMonials option={options_OwlCarousel} />

                {/* End TestiMonial Section */}

                {/* Strat Contact Section #f6f9fe */}

                <Contact />

                {/* end Contact Section */}
            {/* </motion.div> */}
        </>
    )
}
